var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { POSITION_REVAMP_DATA, POSITION_REVAMP_FILTERDATA, POSITION_REVAMP_SUMMARIZE, POSITION_REVAMP_SEARCH, POSITION_SQOFF_VALUES, POSITION_SQOFF_ADDMORE, POSITION_SELECTED_DATA, POSITION_SQOFF_CUSTOM_PAYLOAD, SET_LIST_OF_CHECKED_ITEMS, REQUIRED_ORDER_SLICING, MODIFY_POSITION_ORDER, POSITION_REVAMP_ERROR, POSITION_REVAMP_HIDE_ERROR, POSITION_REVAMP_LOADER, POSITION_REVAMP_STOP_LOADER, POSITION_REVAMP_ADD_MSG, POSITION_REVAMP_CLEAR_MSG, POSITION_RESET_ALL_DATA, } from "@redux/interfaces/Reports/CoreReports/iPositionRevamp";
var initTradeValues = {
    buyQuantity: 0,
    buyCarryForwardQuantity: 0,
    sellCarryForwardQuantity: 0,
    sellQuantity: 0,
    sellAveragePrice: 0,
    buyAveragePrice: 0,
    buyValue: 0,
    sellValue: 0,
    netQuantity: 0,
    price: 0,
    gd: "",
    gn: "",
    mul: "",
    pd: "",
    pn: "",
    carryForward: false,
    ltsz: "",
    cfAvgSlPrc: "",
    cfAvgByPrc: "",
    cfSlQty: "",
    cfByQty: "",
    cfSlAmt: "",
    cfByAmt: "",
};
var initPositionEntity = {
    netQuantity: "",
    averagePrice: "",
    mtm: "",
    mtmChange: "",
    action: "",
    productType: "",
    productCode: "",
    validity: "",
    isClosed: false,
    totalPnL: "",
    totalPnLPercent: "",
    realizedPnL: "",
    realizedPnLPercent: "",
    unRealizedMTM: "",
    unRealizedMTMPercent: "",
    nseTrades: initTradeValues,
    bseTrades: initTradeValues,
    nfoTrades: initTradeValues,
    cdsTrades: initTradeValues,
    bfoTrades: initTradeValues,
    bcdTrades: initTradeValues,
    mcxTrades: initTradeValues,
    ncdexTrades: initTradeValues,
    filterFlags: {
        cnc: false,
        nrml: false,
        mis: false,
        mtf: false,
        bo: false,
    },
    quote: {
        symbol: "",
        isin: "",
        displayName: "",
        description: "",
        tradingSymbol: "",
        assetType: "",
        assetCode: "",
        exchange: "",
        lastTradedPrice: "",
        open: "",
        high: "",
        low: "",
        close: "",
        change: "",
        changePercentage: "",
        optionType: "",
        strikePrice: "",
        expiry: "",
        displayExpiryDate: "",
        displayInstrumentType: "",
        lotSize: "",
        rmsAllowedQty: "",
    },
    scripName: "",
    assetType: "",
    displayName: "",
    assetCode: "",
    lastTradedPrice: 0,
    carryForward: false,
    exchangeTrades: [""],
    isEquityTrade: false,
    positiveMtm: "",
    posFullName: "",
    symbolWithPrdCode: "",
};
var initState = {
    positionData: {
        PositionSummary: {
            date: "",
            time: "",
            totalPnL: "",
            totalPnLPercent: "",
            realizedPnL: "",
            realizedPnLPercent: "",
            unRealizedMTM: "",
            unRealizedMTMPercent: "",
            daysMTM: "",
            daysMTMPercent: "",
            totalPosition: "",
            openPosition: "",
            closedPosition: "",
            positiveTotalPNLCount: 0,
            negativeTotalPNLCount: 0,
        },
        PositionDetailsClosed: [],
        PositionDetailsOpen: [],
        positionsCombined: new Map([
            ["symbol", [initPositionEntity]],
        ]),
    },
    positionSummarize: false,
    search: "",
    filterData: {
        simpleFilter: {
            name: "simpleFilter",
            filters: [],
        },
        assetFilter: {
            name: "assetFilter",
            filters: [],
        },
        underlyingAsset: {
            name: "underlyingAsset",
            filters: [],
        },
        expiryMonth: {
            name: "expiryMonth",
            filters: [],
        },
    },
    sqOffData: {
        buyValue: 0,
        sellValue: 0,
        unrealisedPL: 0,
    },
    sqOffAddMorePositions: null,
    squareOffOnePositionPayload: [
        {
            trdSym: "",
            exc: "",
            action: "",
            dur: "",
            flQty: "",
            ordTyp: "",
            qty: "",
            dscQty: "",
            sym: "",
            mktPro: "",
            lmPrc: "",
            trgPrc: "",
            prdCode: "",
            dtDays: "",
            posSqr: false,
            minQty: "",
            ordSrc: "",
            vnCode: "",
            rmk: "",
            valid: false,
            empOrDependent: "",
        },
    ],
    selectedRowData: initPositionEntity,
    requireOrderSlicing: {
        slicingRequiredForPositions: [],
        nonSlicingPositions: [],
    },
    listOfCheckedItems: [],
    loader: false,
    errorData: {
        error: undefined,
        isOpen: false,
    },
    message: { msg: "", show: false, icon: "" },
    modifyPositionOrder: null,
};
var PositionRevampReducer = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case POSITION_REVAMP_DATA:
            var newState = __assign(__assign({}, state), { positionData: __assign(__assign({}, action.payload.positionData), { positionsCombined: new Map(action.payload.positionData.positionsCombined) }) });
            return newState;
        case POSITION_REVAMP_FILTERDATA:
            return __assign(__assign({}, state), { filterData: action.payload.filterData });
        case POSITION_REVAMP_SUMMARIZE:
            var newSummarizeState = __assign(__assign({}, state), { positionSummarize: action.payload.positionSummarize });
            return newSummarizeState;
        case POSITION_REVAMP_SEARCH:
            return __assign(__assign({}, state), { search: action.payload.search });
        case POSITION_SQOFF_VALUES:
            return __assign(__assign({}, state), { sqOffData: action.payload.sqOffData });
        case POSITION_SQOFF_ADDMORE:
            return __assign(__assign({}, state), { sqOffAddMorePositions: action.payload.sqOffAddMorePositions });
        case POSITION_SELECTED_DATA:
            return __assign(__assign({}, state), { selectedRowData: action.payload.selectedRowData });
        case POSITION_SQOFF_CUSTOM_PAYLOAD:
            return __assign(__assign({}, state), { squareOffOnePositionPayload: action.payload.squareOffOnePositionPayload });
        case SET_LIST_OF_CHECKED_ITEMS:
            return __assign(__assign({}, state), { listOfCheckedItems: action.payload.listOfCheckedItems });
        case REQUIRED_ORDER_SLICING:
            return __assign(__assign({}, state), { requireOrderSlicing: action.payload.requireOrderSlicing });
        case MODIFY_POSITION_ORDER:
            return __assign(__assign({}, state), { modifyPositionOrder: action.payload.modifyPositionOrder });
        case POSITION_REVAMP_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case POSITION_REVAMP_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initState.errorData });
        case POSITION_REVAMP_LOADER:
            return __assign(__assign({}, state), { loader: true });
        case POSITION_REVAMP_STOP_LOADER:
            return __assign(__assign({}, state), { loader: false });
        case POSITION_REVAMP_ADD_MSG:
            return __assign(__assign({}, state), { message: action.payload.message });
        case POSITION_REVAMP_CLEAR_MSG:
            return __assign(__assign({}, state), { message: initState.message });
        case POSITION_RESET_ALL_DATA:
            return __assign({}, initState);
        default:
            return state;
    }
};
export default PositionRevampReducer;
